import {
  SALARY_ALL,
  SALARY_GET,
  SALARY_PUT,
  SALARY_DEL,
  SALARY_POST,
  SALARY_RESET,
  SALARY_LOADING,
  SALARY_ERROR,
} from '../../actions/types';

const initialState = {
  salary: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case SALARY_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SALARY_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SALARY_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case SALARY_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case SALARY_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    case SALARY_RESET:
      return { salary: null, isLoading: true, isCompleted: true };
    case SALARY_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case SALARY_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
